module.exports = __webpack_public_path__ + "static/media/work-24px.37eebdc0.svg";